import { SupportTripInputFilter } from "domain/models/support-trip-input-filter";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { SupportTrip } from "domain/entities/support-trip";
import { ISupportTripRepository } from "domain/contracts/support-trip";

class SupportTripRepository implements ISupportTripRepository {
  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/supportTrip/${id}`);
    return response.data;
  }

  async create(input: Partial<SupportTrip>): Promise<Message<SupportTrip>> {
    const response = await httpClient.post(`/supportTrip`, { data: input });
    return response.data;
  }

  async update(input: Partial<SupportTrip>): Promise<Message<boolean>> {
    const response = await httpClient.put(`/supportTrip/${input.id}`, {
      data: input,
    });
    return response.data;
  }
  
   async getById(id: string): Promise<Message<SupportTrip>> {
    const response = await httpClient.get(`/supportTrip/${id}`);
    return response.data;
  }

  async getAll(filter: SupportTripInputFilter): Promise<Message<SupportTrip[]>> {
    const response = await httpClient.get(`/supportTrip`, { params: filter });
    return response.data;
  }
}

export default new SupportTripRepository();
